import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'cropCanvasPieceImage',
    standalone: false
})
export class CropCanvasPieceImagePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(
    url: SafeResourceUrl,
    crop: {
      x: number;
      y: number;
      w: number;
      h: number;
    },
    photoId?: string
  ): Observable<SafeResourceUrl> {
    console.log(url);
    if (url === null) {
      return of(null);
    }
    return new Observable((subscriber) => {
      const img = new Image();
      img.addEventListener('load', async () => {
        const image = await createImageBitmap(
          img,
          (crop.x / 100) * img.width,
          (crop.y / 100) * img.height,
          (crop.w / 100) * img.width,
          (crop.h / 100) * img.height
        );
        const offscreen = new OffscreenCanvas(image.width, image.height);
        offscreen.getContext('2d').drawImage(image, 0, 0);

        const newUrl = await offscreen
          .convertToBlob()
          .then((b) => URL.createObjectURL(b));

        subscriber.next(
          this.domSanitizer.bypassSecurityTrustResourceUrl(newUrl)
        );
      });
      // @ts-ignore
      img.src = url.changingThisBreaksApplicationSecurity;
    });
  }
}
